<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-mindmap`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M34.171 2a2 2 0 011.415.586l5.828 5.831A2 2 0 0142 9.831V44a2 2 0 01-2 2H8a2 2 0 01-2-2V4a2 2 0 012-2h26.171zM32 6H10v36h28V12.038l-5 .001a1 1 0 01-1-1L31.999 6zM16.063 18.533a3.53 3.53 0 01.435 7.032v2.177h2.68c.527 0 .955.428.955.956v.812a.956.956 0 01-.956.957h-2.679v4.32h2.68c.527 0 .955.428.955.956v.813a.956.956 0 01-.956.956H16.49a2.717 2.717 0 01-2.717-2.717V24.75a3.53 3.53 0 012.29-6.215zm18.283 15.425c.27 0 .487.219.487.488v2.275c0 .27-.218.487-.487.487H22.32a.487.487 0 01-.488-.487v-2.275c0-.27.219-.488.488-.488h12.025zm0-7.041c.27 0 .487.218.487.487v2.275c0 .27-.218.488-.487.488H22.32a.488.488 0 01-.488-.488v-2.275c0-.27.219-.487.488-.487h12.025zm0-7.042c.27 0 .487.218.487.488v2.274c0 .27-.218.488-.487.488H22.32a.488.488 0 01-.488-.488v-2.274c0-.27.219-.488.488-.488h12.025z"/></svg>
</template>
<script>

export default {
  name: 'IconMindmap',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
